module.exports = __webpack_public_path__ + "static/media/news_1.7bf994b3.png";